/* assets/jintcm-home.js — Homepage v2 behaviour: hero slide dots + product carousels.
   No autoplay anywhere (accessibility). Pure helpers are exported for node tests. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') window.JTCMHome = api;
})(this, function () {
  function nextIndex(current, count, dir) {
    if (count <= 1) return 0;
    return (current + dir + count) % count;
  }
  function scrollStep(clientWidth) { return Math.round(clientWidth * 0.8); }
  function canScroll(scrollWidth, clientWidth) { return scrollWidth - clientWidth > 1; }
  function scrollBehavior(prefersReduced) { return prefersReduced ? 'auto' : 'smooth'; }

  if (typeof customElements !== 'undefined') {
    if (!customElements.get('jtcm-hero-slides')) {
      customElements.define('jtcm-hero-slides', class extends HTMLElement {
        connectedCallback() {
          this.slides = [].slice.call(this.querySelectorAll('[data-slide]'));
          this.dots = [].slice.call(this.querySelectorAll('[data-dot]'));
          this.dots.forEach((d, i) => d.addEventListener('click', () => this.show(i)));
          this.show(0);
        }
        show(i) {
          this.slides.forEach((s, k) => { s.hidden = k !== i; });
          this.dots.forEach((d, k) => {
            d.classList.toggle('is-active', k === i);
            if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
          });
        }
      });
    }
    if (!customElements.get('jtcm-scroller')) {
      customElements.define('jtcm-scroller', class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.prev = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          if (!this.track) return;
          var go = (d) => this.track.scrollBy({ left: d * scrollStep(this.track.clientWidth), behavior: scrollBehavior(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) });
          if (this.prev) this.prev.addEventListener('click', () => go(-1));
          if (this.next) this.next.addEventListener('click', () => go(1));
          this.update = () => {
            var show = canScroll(this.track.scrollWidth, this.track.clientWidth);
            [this.prev, this.next].forEach((b) => { if (b) b.hidden = !show; });
          };
          this.update();
          window.addEventListener('resize', this.update);
        }
        disconnectedCallback() { window.removeEventListener('resize', this.update); }
      });
    }
  }
  return { nextIndex: nextIndex, scrollStep: scrollStep, canScroll: canScroll, scrollBehavior: scrollBehavior };
});
